export default __webpack_public_path__ + "static/media/ill-submitted.8ada77a8.svg";